module.exports = __webpack_public_path__ + "static/media/how_to_use_1.b50b0b84.png";